// extracted by mini-css-extract-plugin
export default {"container":"RewardFormContainer_container__3SHe2","saveBtn":"RewardFormContainer_saveBtn__uS4UD","switchContainer":"RewardFormContainer_switchContainer__A7si4"};